import { FC, useEffect, useState } from "react";
import { SidePanelSelectorItem } from "../types";
import { ChatIcon } from "../../../assets/icons";
import { Column, Row } from "../../containers";
import { JustifyContent } from "../../containers/types";
import { useThemeStore } from "../../../stores";
import useSidePanelPageStore from "../store";
import { Chat } from "../../../pages";

const ITEMS: Array<SidePanelSelectorItem> = [
  {
    component: <Chat isSidePanel />,
    icon: ChatIcon,
  },
];

const SidePanelSelector: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const setComponent = useSidePanelPageStore((s) => s.setComponent);

  const [active, setActive] = useState<boolean[]>([]);

  useEffect(() => {
    let res: boolean[] = [];
    ITEMS.forEach(() => res.push(false));
    res[0] = true;
    setComponent(ITEMS[0].component);
    setActive(res);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = (item: SidePanelSelectorItem, i: number): void => {
    setActive((prev) => prev.map((_, _i) => (_i === i ? true : false)));
    setComponent(item.component);
  };

  return (
    <Row
      reverse
      justifyContent={JustifyContent.Start}
      style={{
        padding: "1rem",
        borderBottom: `1px solid ${theme.iconLowOpacity}`,
      }}
      gap={20}
    >
      {ITEMS.map((item, i) => (
        <Column
          key={i}
          style={{ width: 40, height: 40, borderRadius: 7 }}
          background={active[i] ? theme.primary : "transparent"}
          className="transition cursor-pointer"
          justifyContent={JustifyContent.Center}
          props={{ onClick: () => onClick(item, i) }}
        >
          <item.icon
            color={active[i] ? theme.textOnprimary : theme.icon}
            className="transition"
            height={24}
            width={24}
          />
        </Column>
      ))}
    </Row>
  );
};

export default SidePanelSelector;
